/* Calabasas Skin Quiz v2 — UI layer. The recommendation core lives in quiz-engine.js
   (window.SQEngine), which also runs in the offline QA harness. */
(function () {
  var root = document.querySelector('[data-sq]');
  if (!root || !window.SQEngine) return;
  // Flag the page so skin-quiz.css can suppress third-party teasers (Klaviyo) that cover the sticky footer on phones.
  document.body.classList.add('sq-page');
  var dataEl = document.getElementById('sq-products');
  var PRODUCTS = [];
  try { PRODUCTS = JSON.parse(dataEl.textContent) || []; } catch (e) { PRODUCTS = []; }
  var STARTER = null;
  try { var sEl = document.getElementById('sq-starter'); if (sEl) STARTER = JSON.parse(sEl.textContent); } catch (e) { STARTER = null; }
  var BUNDLES = [];
  try { var bEl = document.getElementById('sq-bundles'); if (bEl) BUNDLES = JSON.parse(bEl.textContent) || []; } catch (e) { BUNDLES = []; }

  var E = window.SQEngine;
  var ROUTINE = E.ROUTINE;
  var STEP_LABEL = { cleanser: 'Cleanse', toner: 'Tone', serum: 'Treat', moisturizer: 'Hydrate', sunscreen: 'Protect', 'eye-care': 'Eyes', mask: 'Boost', 'lip-care': 'Lips' };
  /* Three tiers (round 3): Simple 3 = the classic beginner routine, Essential 3 = the default, Complete 5 = everything. */
  var TIER_STEPS = { s3: ['cleanser', 'toner', 'moisturizer'], e3: ['cleanser', 'serum', 'sunscreen'], c5: ROUTINE.slice() };
  var TIER_NAME = { s3: 'Simple 3', e3: 'Essential 3', c5: 'Complete 5' };
  var TIER_CODE = { s3: 'simple3', e3: 'essential3', c5: 'complete5' }; // cart `_tier` + Klaviyo
  var TIER_SUB = { s3: 'Cleanse · Tone · Hydrate', e3: 'Cleanse · Treat · Protect', c5: 'All five steps' };

  var TYPE_COPY = {
    dry: "Your skin runs dry — it makes less of its own oil, so it can feel tight, look dull, or flake, especially in AC or cold air. Your focus: gentle cleansing and layered hydration that rebuilds the barrier.",
    oily: "Your skin makes plenty of oil — great for slower aging, but it can mean shine and congestion. Your focus: balance, not stripping — lightweight hydration keeps oil in check without triggering more.",
    combination: "Classic combination — an oilier T-zone with normal-to-dry cheeks. Your focus: balance the two zones with lightweight, layerable formulas instead of one heavy product everywhere.",
    normal: "Lucky you — your skin reads balanced. Your focus: protect what you've got with daily hydration and sunscreen, and treat specific concerns as they come up."
  };
  var TYPE_NAME = { dry: 'Dry', oily: 'Oily', combination: 'Combination', normal: 'Normal' };
  var CONCERN_LABEL = { acne: 'breakouts', 'dark-spots': 'dark spots', hydration: 'hydration', soothing: 'redness', 'anti-aging': 'fine lines', pores: 'oil & pores' };

  /* Fixed-bundle routing. A bundle CTA appears ONLY when the routine on screen IS the bundle:
     every Essential-3 pick must be one of the bundle's `component:<handle>` tags (emitted by Liquid
     from the live bundle product). No cell table — so a result can never advertise a bundle whose
     contents differ from the cards above it. `?bundle=<handle>` deep links pre-seed the cell below. */
  function bundleComponents(b) { return (b.tags || []).filter(function (t) { return t.indexOf('component:') === 0; }).map(function (t) { return t.slice(10); }); }
  var BUNDLE_PRESEED = {
    'calm-clear-routine': { type: 'normal', concerns: ['acne'] },          // Clear & Calm
    'light-hydration-routine': { type: 'normal', concerns: ['hydration'] }, // Hydrate & Glow
    'even-glow-routine': { type: 'normal', concerns: ['dark-spots'] },      // Even Tone
    'calm-soothe-routine': { type: 'normal', concerns: ['soothing'], sensitive: true }, // Soothe & Restore
    'smooth-firm-routine': { type: 'normal', concerns: ['anti-aging'] }     // Smooth & Firm
  };
  // Retired handles (archived 2026-09-17) keep landing on a result: links already shared in ManyChat / DMs survive.
  var BUNDLE_ALIAS = { 'deep-hydration-routine': 'light-hydration-routine', 'oil-pores-routine': 'calm-clear-routine' };

  var MICRO = ["Nice — that helps us read your skin.", "Got it.", "Almost there.", "Two more required.", "Last required one — the next two are optional.", "Optional: skip if you're not sure.", "Optional — one ingredient you love, one to avoid."];

  var LOVE_OPTS = [['niacinamide', 'Niacinamide'], ['centella', 'Centella / Cica'], ['heartleaf', 'Heartleaf'], ['hyaluronic-acid', 'Hyaluronic Acid'], ['rice', 'Rice'], ['mugwort', 'Mugwort'], ['retinal', 'Retinal'], ['collagen', 'Collagen'], ['tranexamic-acid', 'Tranexamic Acid'], ['peptide', 'Peptides']];
  var AVOID_OPTS = [['fragrance', 'Fragrance'], ['essential-oil', 'Essential oils'], ['drying-alcohol', 'Drying alcohol'], ['strong-active', 'Strong actives'], ['nut-allergen', 'Nut allergy'], ['niacinamide', 'Niacinamide'], ['retinal', 'Retinal'], ['tea-tree', 'Tea tree']];

  /* ---------- questions ---------- */
  var Q = [
    { id: 'q1', multi: true, max: 2, eyebrow: 'Your goal', title: 'What do you most want to improve?', sub: 'Pick up to two.', options: [
      { l: 'Calm breakouts', h: 'Spots, congestion, post-acne marks', concern: 'acne' },
      { l: 'Fade dark spots / even tone', h: 'Sun spots, old marks, dullness', concern: 'dark-spots' },
      { l: 'Hydrate / plump', h: 'Tight, dull or dehydrated-looking skin', concern: 'hydration' },
      { l: 'Soothe redness / sensitivity', h: 'Flushes, stings or reacts easily', concern: 'soothing', sensitive: true },
      { l: 'Smooth fine lines / firm', h: 'Early lines, loss of bounce', concern: 'anti-aging' },
      { l: 'Control oil / minimize pores', h: 'Shine by noon, visible pores', concern: 'pores' },
      { l: "I'm just starting — keep it simple", h: 'A three-step routine you can actually keep', concern: 'none', exclusive: true }
    ] },
    { id: 'q2', eyebrow: 'About you', title: 'Your age range?', options: [
      { l: 'Teens–20s', pts: { oily: 1 } }, { l: '30s', pts: {} }, { l: '40s', pts: { dry: 1 } }, { l: '50+', pts: { dry: 2 } }
    ] },
    { id: 'q3', eyebrow: 'Your world', title: 'The climate where you live?', options: [
      { l: 'Hot & humid', pts: { oily: 1 } }, { l: 'Dry or cold', pts: { dry: 1 } }, { l: 'Mild / temperate', pts: {} }, { l: 'Four distinct seasons', pts: { combination: 1 } }
    ] },
    { id: 'q4', eyebrow: 'Your days', title: "Most days, you're…", options: [
      { l: 'Mostly indoors, in AC or heat', pts: { dry: 1 } },
      { l: 'A mix of both', pts: {} },
      { l: 'Outdoors & active, sweating often', pts: { oily: 1 }, outdoors: true }
    ] },
    { id: 'q5', eyebrow: 'Sun', title: 'Do you wear sunscreen daily?', options: [
      { l: 'Yes, every day', pts: {} }, { l: 'Sometimes', spf: true }, { l: 'Rarely', spf: true }
    ] },
    { id: 'q6', eyebrow: 'Your skin', title: 'Day to day, your skin usually…', options: [
      { l: 'Gets shiny / oily', pts: { oily: 2 }, q6: 'oily' },
      { l: 'Feels tight or flaky', pts: { dry: 2 }, q6: 'dry' },
      { l: 'Shiny T-zone, drier cheeks', pts: { combination: 2 }, q6: 'combination' },
      { l: 'Gets red or irritated easily', sensitive: true },
      { l: 'Feels balanced / not sure', pts: {} }
    ] },
    { id: 'q7', optional: true, eyebrow: 'Optional', title: 'A few hours after washing, your skin feels…', options: [
      { l: 'Tight / dry', pts: { dry: 2 } },
      { l: 'Comfortable', pts: { normal: 1 } },
      { l: 'Oily all over', pts: { oily: 2 } },
      { l: 'Oily T-zone only', pts: { combination: 2 } },
      { l: "I'd rather skip", pts: {} }
    ] },
    { id: 'q8', optional: true, ingredient: true, eyebrow: 'Optional', title: 'Any ingredient you love — or one to avoid?' }
  ];
  var REQUIRED_COUNT = 6;

  /* ---------- state ---------- */
  var state = {
    idx: 0, answers: {}, love: null, avoid: null,
    type: 'normal', concerns: [], sensitive: false, spf: false, outdoors: false,
    tier: 'e3', swaps: {}, addMoist: false, addSpf: false, tierChosen: false,
    src: null, video: null, topic: null, bundleReq: null,
    result: null, rid: null
  };

  function recompute() {
    var pts = { dry: 0, combination: 0, oily: 0 }, normalPts = 0;
    state.concerns = []; state.sensitive = false; state.spf = false; state.outdoors = false;
    var q6type = null;
    Q.forEach(function (q) {
      var a = state.answers[q.id];
      if (a == null) return;
      if (q.multi) {
        a.forEach(function (i) {
          var o = q.options[i]; if (!o) return;
          if (o.concern && o.concern !== 'none') state.concerns.push(o.concern);
          if (o.sensitive) state.sensitive = true;
        });
        return;
      }
      var o = q.options[a]; if (!o) return;
      if (o.pts) Object.keys(o.pts).forEach(function (k) { if (k === 'normal') normalPts += o.pts[k]; else pts[k] += o.pts[k]; });
      if (o.q6) q6type = o.q6;
      if (o.sensitive) state.sensitive = true;
      if (o.spf) state.spf = true;         // Q5 only
      if (o.outdoors) state.outdoors = true; // Q4 only
    });
    var max = Math.max(pts.dry, pts.combination, pts.oily);
    if (max === 0) state.type = 'normal';
    else if (normalPts >= max && max <= 1) state.type = 'normal';
    else {
      var leaders = ['dry', 'combination', 'oily'].filter(function (k) { return pts[k] === max; });
      state.type = leaders.length === 1 ? leaders[0] : (q6type && leaders.indexOf(q6type) > -1 ? q6type : 'combination');
    }
  }

  function isStarter() {
    var a = state.answers.q1;
    return !!(a && a.length && Q[0].options[a[0]] && Q[0].options[a[0]].concern === 'none');
  }

  /* ---------- ?r= encoding ---------- */
  function encodeR() {
    var f = [];
    f.push('t.' + state.type);
    f.push('c.' + (state.concerns.length ? state.concerns.join('.') : 'none'));
    f.push('f.' + (state.sensitive ? 's' : '') + (state.spf ? 'p' : '') + (state.outdoors ? 'o' : ''));
    f.push('l.' + (state.love || 'x'));
    f.push('a.' + (state.avoid || 'x'));
    f.push('tr.' + state.tier + (state.addMoist ? 'm' : '') + (state.addSpf ? 'p' : ''));
    var sw = Object.keys(state.swaps).map(function (s) { return s + '~' + state.swaps[s]; });
    if (sw.length) f.push('sw.' + sw.join('!'));
    if (state.src) f.push('src.' + state.src);
    if (state.video) f.push('v.' + state.video);
    if (state.topic) f.push('tp.' + state.topic);
    return 'v2-' + f.join('_');
  }
  function decodeR(r) {
    if (!r || r.indexOf('v2-') !== 0) return false;
    var ok = false;
    r.slice(3).split('_').forEach(function (f) {
      var d = f.indexOf('.'); if (d < 0) return;
      var k = f.slice(0, d), v = f.slice(d + 1);
      if (k === 't' && TYPE_COPY[v]) { state.type = v; ok = true; }
      else if (k === 'c') state.concerns = v === 'none' ? [] : v.split('.').filter(function (c) { return CONCERN_LABEL[c]; });
      else if (k === 'f') { state.sensitive = v.indexOf('s') > -1; state.spf = v.indexOf('p') > -1; state.outdoors = v.indexOf('o') > -1; }
      else if (k === 'l') state.love = v === 'x' ? null : v;
      else if (k === 'a') state.avoid = v === 'x' ? null : v;
      else if (k === 'tr') { var tc = v.slice(0, 2), tf = v.slice(2); state.tier = TIER_STEPS[tc] ? tc : 'e3'; state.tierChosen = true; state.addMoist = state.tier === 'e3' && tf.indexOf('m') > -1; state.addSpf = state.tier === 's3' && tf.indexOf('p') > -1; }
      else if (k === 'sw') v.split('!').forEach(function (p) { var i = p.indexOf('~'); if (i > 0) state.swaps[p.slice(0, i)] = p.slice(i + 1); });
      else if (k === 'src') state.src = v;
      else if (k === 'v') state.video = v;
      else if (k === 'tp') state.topic = v;
    });
    return ok;
  }
  function hashId(str) { var h = 5381; for (var i = 0; i < str.length; i++) h = ((h << 5) + h + str.charCodeAt(i)) >>> 0; return 'q' + h.toString(36); }

  /* ---------- recommendation (delegates to the engine) ---------- */
  function buildResult() {
    var answers = {
      type: state.type, concerns: state.concerns.slice(), sensitive: state.sensitive, spf: state.spf, outdoors: state.outdoors,
      love: state.love, avoid: state.avoid, starter: isStarter() && !state.concerns.length
    };
    state.result = E.recommend(answers, PRODUCTS);
    // apply swaps (only within the step's scored set)
    ROUTINE.forEach(function (s) { var st = state.result.steps[s]; if (st) st.ranked = (st.pick ? [st.pick] : []).concat(st.alternatives); });
    Object.keys(state.swaps).forEach(function (s) {
      var st = state.result.steps[s]; if (!st) return;
      var all = st.ranked;
      var m = all.filter(function (p) { return p.handle === state.swaps[s]; })[0];
      if (m && st.pick && m.handle !== st.pick.handle) {
        st.alternatives = all.filter(function (p) { return p.handle !== m.handle; });
        st.pick = m;
        st.why = 'Your swap — kept in your routine.';
        st.patchNote = false;
      } else if (!m) delete state.swaps[s];
    });
    var r = encodeR();
    state.rid = hashId(r);
    return r;
  }

  function currentPick(step) { var st = state.result && state.result.steps[step]; return st && st.pick ? st.pick : null; }
  function tierSteps() {
    var steps = TIER_STEPS[state.tier].slice();
    if (state.tier === 'e3' && state.addMoist) steps.splice(2, 0, 'moisturizer');
    if (state.tier === 's3' && state.addSpf) steps.push('sunscreen');
    return steps;
  }
  function setTier(t) {
    state.tier = TIER_STEPS[t] ? t : 'e3'; state.tierChosen = true;
    if (state.tier !== 'e3') state.addMoist = false;
    if (state.tier !== 's3') state.addSpf = false;
    refreshR(); renderSteps(); renderSummary(); renderFooter();
  }
  function tierTotal() { return tierSteps().reduce(function (a, s) { var p = currentPick(s); return a + (p ? p.price : 0); }, 0); }
  function money(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
  /* Email clients don't resolve protocol-relative URLs — make image links absolute for Klaviyo. */
  function absUrl(u) { if (!u) return ''; if (u.indexOf('//') === 0) return 'https:' + u; if (u.indexOf('/') === 0) return location.origin + u; return u; }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  /* ---------- screens ---------- */
  var screens = {
    intro: root.querySelector('[data-sq-screen="intro"]'),
    quiz: root.querySelector('[data-sq-screen="quiz"]'),
    result: root.querySelector('[data-sq-screen="result"]')
  };
  function show(name) {
    Object.keys(screens).forEach(function (k) { screens[k].hidden = (k !== name); });
    var bar = root.querySelector('[data-sq-bar]');
    if (name === 'intro') bar.style.width = '0%';
    if (name === 'result') bar.style.width = '100%';
    var foot = root.querySelector('[data-sq-footer]');
    if (foot) foot.hidden = (name !== 'result');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  /* ---------- quiz rendering ---------- */
  function renderQuestion() {
    var q = Q[state.idx];
    var count = root.querySelector('[data-sq-count]');
    count.textContent = q.optional ? ('Optional — ' + (state.idx - REQUIRED_COUNT + 1) + ' of 2') : ('Question ' + (state.idx + 1) + ' of ' + REQUIRED_COUNT);
    var eb = root.querySelector('[data-sq-q-eyebrow]'); if (eb) eb.textContent = q.eyebrow || '';
    root.querySelector('[data-sq-q-title]').textContent = q.title;
    root.querySelector('[data-sq-bar]').style.width = Math.round((state.idx / Q.length) * 100) + '%';
    var wrap = root.querySelector('[data-sq-options]');
    wrap.innerHTML = '';

    wrap.className = 'sq-options' + (q.multi ? ' sq-options--multi' : '');
    if (q.ingredient) { wrap.setAttribute('role', 'group'); renderQ8(wrap); }
    else if (q.multi) {
      // multi-select drawn as toggle chips (role=group + aria-pressed), never as radios
      var sel = state.answers[q.id] || [];
      wrap.setAttribute('role', 'group'); wrap.setAttribute('aria-label', q.title);
      var counter = document.createElement('p'); counter.className = 'sq-micro sq-options__count'; counter.setAttribute('aria-live', 'polite');
      counter.textContent = sel.length ? (sel.length + ' of ' + q.max + ' picked') : ('Pick up to ' + q.max);
      wrap.appendChild(counter);
      q.options.forEach(function (o, i) {
        var b = optBtn(o.l, sel.indexOf(i) > -1, true, o.h);
        b.addEventListener('click', function () { toggleMulti(q, i); });
        wrap.appendChild(b);
      });
      var nextWrap = document.createElement('div'); nextWrap.className = 'sq-options__next';
      var next = document.createElement('button');
      next.type = 'button'; next.className = 'sq-btn sq-btn--next'; next.textContent = 'Next';
      next.disabled = !sel.length;
      next.addEventListener('click', function () { if ((state.answers[q.id] || []).length) next.disabled || nextQ(); });
      nextWrap.appendChild(next); wrap.appendChild(nextWrap);
    } else {
      wrap.setAttribute('role', 'radiogroup'); wrap.setAttribute('aria-label', q.title);
      q.options.forEach(function (o, i) {
        var b = optBtn(o.l, state.answers[q.id] === i, false, o.h);
        b.addEventListener('click', function () { state.answers[q.id] = i; recompute(); setTimeout(nextQ, 180); });
        wrap.appendChild(b);
      });
    }
    root.querySelector('[data-sq-back]').hidden = state.idx === 0;
    root.querySelector('[data-sq-skip]').hidden = !q.optional;
    root.querySelector('[data-sq-micro]').textContent = MICRO[state.idx] || '';
  }
  function optBtn(label, checked, multi, help) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'sq-opt' + (multi ? ' sq-opt--chip' : '');
    if (multi) b.setAttribute('aria-pressed', checked ? 'true' : 'false');
    else { b.setAttribute('role', 'radio'); b.setAttribute('aria-checked', checked ? 'true' : 'false'); }
    b.innerHTML = '<span class="sq-opt__dot" aria-hidden="true"></span><span class="sq-opt__text"><span class="sq-opt__label">' + esc(label) + '</span>' + (help ? '<span class="sq-opt__help">' + esc(help) + '</span>' : '') + '</span>';
    return b;
  }
  function toggleMulti(q, i) {
    var sel = (state.answers[q.id] || []).slice();
    var o = q.options[i];
    var at = sel.indexOf(i);
    if (at > -1) sel.splice(at, 1);
    else {
      if (o.exclusive) sel = [i];
      else { sel = sel.filter(function (j) { return !q.options[j].exclusive; }); if (sel.length >= q.max) sel.shift(); sel.push(i); }
    }
    state.answers[q.id] = sel;
    recompute();
    renderQuestion();
  }
  function renderQ8(wrap) {
    function chipRow(title, opts, cur, set) {
      var h = document.createElement('div'); h.className = 'sq-chips';
      var t = document.createElement('p'); t.className = 'sq-chips__title'; t.textContent = title; h.appendChild(t);
      var row = document.createElement('div'); row.className = 'sq-chips__row';
      opts.forEach(function (o) {
        var c = document.createElement('button');
        c.type = 'button'; c.className = 'sq-chip' + (cur === o[0] ? ' is-on' : '');
        c.textContent = o[1];
        c.addEventListener('click', function () { set(cur === o[0] ? null : o[0]); renderQuestion(); });
        row.appendChild(c);
      });
      h.appendChild(row);
      return h;
    }
    wrap.appendChild(chipRow('One you love', LOVE_OPTS, state.love, function (v) { state.love = v; }));
    wrap.appendChild(chipRow('One to avoid', AVOID_OPTS, state.avoid, function (v) { state.avoid = v; }));
    var done = document.createElement('button');
    done.type = 'button'; done.className = 'sq-btn sq-btn--next'; done.textContent = 'See my routine';
    done.addEventListener('click', nextQ);
    wrap.appendChild(done);
  }
  function nextQ() {
    if (state.idx < Q.length - 1) { state.idx++; renderQuestion(); }
    else finish();
  }
  function back() { if (state.idx > 0) { state.idx--; renderQuestion(); } }
  function skipQ() { var q = Q[state.idx]; if (q.id === 'q8') { state.love = null; state.avoid = null; } else delete state.answers[q.id]; recompute(); nextQ(); }

  function finish() {
    recompute();
    // "I'm just starting" defaults to Simple 3 (Cleanse · Tone · Hydrate); everyone else to Essential 3
    if (!state.tierChosen) { state.tier = isStarter() ? 's3' : 'e3'; state.addMoist = false; state.addSpf = false; }
    var r = buildResult();
    try { history.pushState({ sq: 'result' }, '', location.pathname + '?r=' + encodeURIComponent(r) + location.hash); } catch (e) {}
    renderResult();
    show('result');
  }

  /* ---------- result rendering ---------- */
  function renderResult() {
    var res = state.result;
    var typeName = TYPE_NAME[state.type] || 'Normal';
    // Headline leads with the goal (ManyChat visitors arrive from a video about a concern), the type is the sub-line.
    var phrases = state.concerns.map(function (c) { return E.CONCERN_PHRASE[c]; }).filter(Boolean);
    var headline = res.starter || !phrases.length ? 'Your first routine — kept simple' : 'Your routine for ' + phrases.join(' and ');
    root.querySelector('[data-sq-type-head]').textContent = headline;
    var subEl = root.querySelector('[data-sq-sub]');
    if (subEl) subEl.textContent = 'Built for ' + typeName.toLowerCase() + ' skin' + (state.sensitive ? ' — reactive-friendly' : '');
    root.querySelector('[data-sq-edu]').textContent = TYPE_COPY[state.type] || TYPE_COPY.normal;
    var band = root.querySelector('[data-sq-band]');
    var bandImg = root.getAttribute('data-band-image');
    if (bandImg) band.style.backgroundImage = "url('" + bandImg + "')";

    var shop = root.querySelector('[data-sq-shop-all]');
    if (shop) {
      shop.href = '/collections/' + state.type;
      shop.textContent = 'Shop all for ' + (TYPE_NAME[state.type] || '') + ' skin →';
    }

    // starter path
    var starterWrap = root.querySelector('[data-sq-starter]');
    if (res.starter && STARTER) {
      starterWrap.hidden = false;
      starterWrap.innerHTML =
        '<div class="sq-starter__card">' +
          (STARTER.image ? '<img src="' + esc(STARTER.image) + '" alt="' + esc(STARTER.title) + '">' : '') +
          '<div><p class="sq-eyebrow">Start simple</p><h3 class="sq-h3">' + esc(STARTER.title) + ' — ' + money(STARTER.price) + '</h3>' +
          '<p class="sq-lead">Cleanser, hydrator and daily protection in one set — the easiest way in. Prefer it hand-picked? Your custom routine is below.</p>' +
          '<button type="button" class="sq-btn" data-sq-starter-add>Add The Founding Set — ' + money(STARTER.price) + '</button></div></div>';
      var sBtn = starterWrap.querySelector('[data-sq-starter-add]');
      sBtn.addEventListener('click', function () { addLines([{ id: STARTER.variantId, quantity: 1, properties: { _routine: state.rid, _step: 'starter', _tier: 'starter' } }], sBtn, 'Set added ✓'); });
    } else { starterWrap.hidden = true; starterWrap.innerHTML = ''; }

    // bundle CTA (only when the matching fixed bundle exists & is live)
    var bWrapCta = root.querySelector('[data-sq-bundle-cta]');
    var e3 = TIER_STEPS.e3.map(currentPick).filter(Boolean).map(function (p) { return p.handle; });
    var unsafe = function (b) { return state.sensitive && (b.tags || []).some(function (t) { return t === 'caution:strong-active' || t === 'caution:drying-alcohol'; }); };
    // exact match: the three picks on screen are all components of a live bundle
    var exact = BUNDLES.filter(function (b) {
      if (!b.available || unsafe(b)) return false;
      var comps = bundleComponents(b);
      return e3.length === 3 && e3.every(function (h) { return comps.indexOf(h) > -1; });
    })[0];
    // deep link: the set the visitor asked for, shown as such even when the quiz's own picks differ
    var requested = state.bundleReq ? BUNDLES.filter(function (b) { return b.handle === state.bundleReq && b.available && !unsafe(b); })[0] : null;
    if (exact) {
      bWrapCta.hidden = false;
      bWrapCta.innerHTML = '<a class="sq-btn" href="/products/' + esc(exact.handle) + '">Get the ' + esc(exact.title) + ' — ' + money(exact.price) + '</a>' +
        '<p class="sq-micro">This set is exactly the three steps below, with a sheet mask included. Or customize step by step.</p>';
    } else if (requested) {
      bWrapCta.hidden = false;
      bWrapCta.innerHTML = '<p class="sq-eyebrow">The set you asked about</p>' +
        '<a class="sq-btn" href="/products/' + esc(requested.handle) + '">Get the ' + esc(requested.title) + ' — ' + money(requested.price) + '</a>' +
        '<p class="sq-micro">Below is the routine our quiz builds for this skin — it may differ from the set. Swap any step.</p>';
    } else { bWrapCta.hidden = true; bWrapCta.innerHTML = ''; }

    renderSteps();
    renderBoosters();
    renderSummary();
    renderFooter();
  }

  function renderSteps() {
    var stepsWrap = root.querySelector('[data-sq-steps]');
    stepsWrap.innerHTML = '';
    var inTier = tierSteps();
    var primary = ROUTINE.filter(function (s) { return inTier.indexOf(s) > -1; });
    var extra = ROUTINE.filter(function (s) { return inTier.indexOf(s) === -1; });
    // Row 1: the steps in the chosen tier. Row 2 (under one divider): what Complete 5 adds.
    var row1 = document.createElement('div');
    row1.className = 'sq-steps__row sq-steps__row--' + primary.length;
    // Step names only — routine-position numbers read 1·3·5 on a three-card tier row (round 4).
    primary.forEach(function (s, i) { row1.appendChild(cardEl(s, 0, true, i < 3)); });
    stepsWrap.appendChild(row1);
    if (extra.length) {
      var div = document.createElement('p');
      div.className = 'sq-steps__divider';
      div.innerHTML = '<span>Added in Complete 5 — ' + esc(extra.map(function (s) { return STEP_LABEL[s]; }).join(' · ')) + '</span>';
      stepsWrap.appendChild(div);
      var row2 = document.createElement('div');
      row2.className = 'sq-steps__row sq-steps__row--extra sq-steps__row--' + extra.length;
      extra.forEach(function (s) { row2.appendChild(cardEl(s, 0, false, false)); });
      stepsWrap.appendChild(row2);
    }
  }

  function ratingLine(p) {
    if (!p || !(p.rc >= 20) || !(p.rating > 0)) return '';
    return '<span class="sq-card__rating">★ ' + (Math.round(p.rating * 10) / 10).toFixed(1) + ' · ' + p.rc + ' reviews</span>';
  }

  function cardEl(step, num, inTier, eager) {
    var st = state.result.steps[step];
    var card = document.createElement('div');
    card.className = 'sq-card' + (inTier ? '' : ' sq-card--extra');
    card.setAttribute('data-sq-card', step);
    var p = st && st.pick;
    if (!p) {
      card.innerHTML = '<div class="sq-card__step">' + (num ? '<span class="sq-card__num">' + num + '</span>' : '') + esc(STEP_LABEL[step] || step) + '</div>' +
        '<div class="sq-card__body"><p class="sq-card__why">Restocking — this step is back soon. Your routine total skips it for now.</p></div>';
      return card;
    }
    var multi = st.alternatives.length > 0;
    var img = p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" width="480" height="480"' + (eager ? '' : ' loading="lazy"') + '>' : '';
    var swapped = !!state.swaps[step];
    // Swap tray: "Swap ›" shows the next alternative; once swapped the card offers "Swap back" and "Next ›".
    var swap = !multi ? '' : (swapped
      ? '<div class="sq-card__swaps"><button type="button" class="sq-card__swaplink" data-sq-swapback>Swap back</button><button type="button" class="sq-card__swaplink" data-sq-next>Next ›</button></div>'
      : '<div class="sq-card__swaps"><button type="button" class="sq-card__swaplink" data-sq-next>Swap ›</button></div>');
    var note = st.patchNote ? '<p class="sq-card__note">Patch-test first — it carries light fragrance and your skin flags as reactive.</p>' : '';
    card.innerHTML =
      '<div class="sq-card__step">' + (num ? '<span class="sq-card__num">' + num + '</span>' : '') + esc(STEP_LABEL[step] || step) + '</div>' +
      '<div class="sq-card__media">' + img + '</div>' +
      '<div class="sq-card__body">' +
        '<a class="sq-card__title" href="' + esc(p.url || ('/products/' + p.handle)) + '">' + esc(p.title) + '</a>' +
        '<p class="sq-card__price">' + money(p.price) + ratingLine(p) + '</p>' +
        ((step === 'sunscreen' && state.spf) ? '<p class="sq-card__spf">Don’t skip this one</p>' : '') +
        '<p class="sq-card__why">' + esc(st.why) + '</p>' + swap + note +
        '<div class="sq-card__add"><button type="button" data-sq-add>Add to bag</button></div>' +
      '</div>';
    function commitSwap() {
      var r = buildResult();
      try { history.replaceState({ sq: 'result' }, '', location.pathname + '?r=' + encodeURIComponent(r) + location.hash); } catch (e) {}
      renderSteps(); renderSummary(); renderFooter();
    }
    var nxt = card.querySelector('[data-sq-next]'), back = card.querySelector('[data-sq-swapback]');
    if (nxt) nxt.addEventListener('click', function () {
      // cycle through the engine's ranked list for this step; arriving back at #1 clears the swap
      var ranked = st.ranked || [st.pick].concat(st.alternatives);
      var idx = ranked.map(function (x) { return x.handle; }).indexOf(p.handle);
      var next = ranked[(idx + 1) % ranked.length];
      if (!next) return;
      if (next.handle === ranked[0].handle) delete state.swaps[step]; else state.swaps[step] = next.handle;
      commitSwap();
    });
    if (back) back.addEventListener('click', function () { delete state.swaps[step]; commitSwap(); });
    var add = card.querySelector('[data-sq-add]');
    add.addEventListener('click', function () {
      addLines([{ id: p.variantId, quantity: 1, properties: { _routine: state.rid, _step: step, _tier: 'single' } }], add, 'Added ✓');
    });
    return card;
  }

  function renderBoosters() {
    var bWrap = root.querySelector('[data-sq-boosters]');
    var bList = root.querySelector('[data-sq-booster-list]');
    bList.innerHTML = '';
    var bs = state.result.boosters;
    if (bs.length) {
      bWrap.hidden = false;
      bs.forEach(function (b) {
        var p = b.pick;
        var card = document.createElement('div');
        card.className = 'sq-boost';
        card.innerHTML =
          '<div class="sq-boost__media">' + (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" width="480" height="480" loading="lazy">' : '') + '</div>' +
          '<div class="sq-boost__body"><p class="sq-boost__step">' + esc(STEP_LABEL[b.step] || b.step) + '</p>' +
          '<a class="sq-card__title" href="' + esc(p.url || ('/products/' + p.handle)) + '">' + esc(p.title) + '</a>' +
          '<p class="sq-card__price">' + money(p.price) + ratingLine(p) + '</p><p class="sq-card__why">' + esc(b.why) + '</p>' +
          '<div class="sq-card__add"><button type="button" data-sq-add>Add to bag</button></div></div>';
        var add = card.querySelector('[data-sq-add]');
        add.addEventListener('click', function () { addLines([{ id: p.variantId, quantity: 1, properties: { _routine: state.rid, _step: b.step, _tier: 'booster' } }], add, 'Added ✓'); });
        bList.appendChild(card);
      });
    } else bWrap.hidden = true;
  }

  function tierLabel() { return TIER_NAME[state.tier] + ((state.tier === 'e3' && state.addMoist) || (state.tier === 's3' && state.addSpf) ? ' +' : ''); }
  /* Totals per tier from the picks on screen (swaps included) */
  function tierTotals() {
    var save = { tier: state.tier, m: state.addMoist, p: state.addSpf }, out = {};
    state.addMoist = false; state.addSpf = false;
    ['s3', 'e3', 'c5'].forEach(function (t) { state.tier = t; out[t] = tierTotal(); });
    state.tier = save.tier; state.addMoist = save.m; state.addSpf = save.p;
    return out;
  }
  /* Share: native share sheet on mobile → clipboard → legacy execCommand copy → last resort, show the link selected. */
  function shareRoutine(btn) {
    var url = location.origin + location.pathname + '?r=' + encodeURIComponent(encodeR());
    var done = function (label) { btn.textContent = label; setTimeout(function () { btn.textContent = 'Share my routine'; }, 1800); };
    function legacyCopy() {
      try {
        var ta = document.createElement('textarea'); ta.value = url; ta.setAttribute('readonly', ''); ta.style.cssText = 'position:fixed;left:-9999px;top:0';
        document.body.appendChild(ta); ta.select(); ta.setSelectionRange(0, url.length);
        var ok = document.execCommand('copy'); document.body.removeChild(ta); return ok;
      } catch (e) { return false; }
    }
    function showLink() {
      var box = btn.parentNode.querySelector('[data-sq-sharebox]');
      if (!box) {
        box = document.createElement('input'); box.type = 'text'; box.readOnly = true; box.className = 'sq-sharebox'; box.setAttribute('data-sq-sharebox', ''); box.setAttribute('aria-label', 'Your routine link');
        btn.parentNode.appendChild(box);
      }
      box.value = url; box.focus(); box.select();
      done('Copy this link');
    }
    if (navigator.share) {
      navigator.share({ title: 'My Calabasas routine', text: 'The routine the Calabasas skin quiz built for me', url: url }).then(function () { done('Shared'); }).catch(function (e) { if (e && e.name === 'AbortError') done('Share my routine'); else if (legacyCopy()) done('Link copied'); else showLink(); });
      return;
    }
    var p = navigator.clipboard && navigator.clipboard.writeText ? navigator.clipboard.writeText(url) : Promise.reject();
    p.then(function () { done('Link copied'); }, function () { if (legacyCopy()) done('Link copied'); else showLink(); });
  }

  function renderSummary() {
    var sum = root.querySelector('[data-sq-summary]');
    var tot = tierTotals();
    var cards = ['s3', 'e3', 'c5'].map(function (t) {
      var on = state.tier === t;
      return '<button type="button" class="sq-tier' + (on ? ' is-on' : '') + '" data-sq-tier="' + t + '" role="radio" aria-checked="' + (on ? 'true' : 'false') + '">' +
        '<span class="sq-tier__name">' + TIER_NAME[t] + '</span><strong>' + money(tot[t]) + '</strong><span class="sq-tier__sub">' + TIER_SUB[t] + '</span></button>';
    }).join('');
    var nudge = '';
    if (state.type === 'dry' && state.tier === 'e3') nudge = '<label class="sq-moist"><input type="checkbox" data-sq-moist' + (state.addMoist ? ' checked' : '') + '> Add your moisturizer — dry skin does better with it (+' + money((currentPick('moisturizer') || { price: 0 }).price) + ')</label>';
    if (state.tier === 's3' && currentPick('sunscreen')) nudge = '<label class="sq-moist"><input type="checkbox" data-sq-spf' + (state.addSpf ? ' checked' : '') + '> Add your sunscreen — most visible aging starts without it (+' + money(currentPick('sunscreen').price) + ')</label>';
    sum.innerHTML =
      '<div class="sq-tiers" role="radiogroup" aria-label="Routine size">' + cards + '</div>' + nudge +
      '<div class="sq-summary__actions">' +
        '<button type="button" class="sq-btn sq-summary__cta" data-sq-add-all>Add ' + tierLabel() + ' — ' + money(tierTotal()) + '</button>' +
        '<div class="sq-summary__quiet">' +
          '<a class="sq-link sq-viewbag" data-sq-viewbag href="/cart" hidden>View bag →</a>' +
          '<button type="button" class="sq-link" data-sq-share>Share my routine</button>' +
        '</div>' +
      '</div>';
    sum.querySelectorAll('[data-sq-tier]').forEach(function (b) { b.addEventListener('click', function () { setTier(b.getAttribute('data-sq-tier')); }); });
    var mo = sum.querySelector('[data-sq-moist]');
    if (mo) mo.addEventListener('change', function () { state.addMoist = mo.checked; refreshR(); renderSteps(); renderSummary(); renderFooter(); });
    var sp = sum.querySelector('[data-sq-spf]');
    if (sp) sp.addEventListener('change', function () { state.addSpf = sp.checked; refreshR(); renderSteps(); renderSummary(); renderFooter(); });
    sum.querySelector('[data-sq-add-all]').addEventListener('click', function () { addRoutine(this); });
    sum.querySelector('[data-sq-share]').addEventListener('click', function () { shareRoutine(this); });
    syncBag();
  }

  function renderFooter() {
    var foot = root.querySelector('[data-sq-footer]');
    if (!foot) return;
    foot.hidden = screens.result.hidden;
    foot.innerHTML =
      '<div class="sq-footer__tiers" role="radiogroup" aria-label="Routine size">' +
        ['s3', 'e3', 'c5'].map(function (t) { return '<button type="button" class="sq-footer__tier' + (state.tier === t ? ' is-on' : '') + '" data-sq-tier="' + t + '" role="radio" aria-checked="' + (state.tier === t ? 'true' : 'false') + '">' + TIER_NAME[t] + '</button>'; }).join('') +
      '</div>' +
      '<button type="button" class="sq-btn sq-footer__cta" data-sq-add-all>Add ' + tierLabel() + ' — ' + money(tierTotal()) + '</button>' +
      '<a class="sq-link sq-footer__bag" data-sq-viewbag href="/cart" hidden>View bag →</a>';
    foot.querySelectorAll('[data-sq-tier]').forEach(function (b) { b.addEventListener('click', function () { setTier(b.getAttribute('data-sq-tier')); }); });
    foot.querySelector('[data-sq-add-all]').addEventListener('click', function () { addRoutine(this); });
    syncBag();
  }

  /* The theme has no cart drawer, so after an add the shopper needs somewhere to go:
     a persistent "View bag (N) →" wherever the CTA is, driven by the real cart count. */
  function syncBag() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      root.querySelectorAll('[data-sq-viewbag]').forEach(function (el) {
        el.hidden = !c.item_count;
        el.textContent = 'View bag (' + c.item_count + ') →';
      });
    }).catch(function () {});
  }

  function refreshR() {
    var r = encodeR(); state.rid = hashId(r);
    try { history.replaceState({ sq: 'result' }, '', location.pathname + '?r=' + encodeURIComponent(r) + location.hash); } catch (e) {}
  }

  /* ---------- cart ---------- */
  function routineLines() {
    var lines = [];
    tierSteps().forEach(function (s) {
      var p = currentPick(s);
      if (p && p.available) lines.push({ id: p.variantId, quantity: 1, properties: { _routine: state.rid, _step: s, _tier: TIER_CODE[state.tier] || 'essential3' }, _title: p.title });
    });
    return lines;
  }

  function postAdd(items) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items.map(function (i) { return { id: i.id, quantity: i.quantity, properties: i.properties }; }) })
    }).then(function (r) { return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; }); });
  }

  /* One batched call; on a 422 retry once without the offending line and say so honestly. */
  function addRoutine(btn) {
    var items = routineLines();
    if (!items.length) return;
    var total = tierSteps().filter(function (s) { return currentPick(s); }).length;
    btn.disabled = true; var orig = btn.textContent; btn.textContent = 'Adding routine…';
    postAdd(items).then(function (res) {
      if (res.ok) return { added: items.length, total: total };
      if (res.status === 422) {
        var desc = ((res.data && (res.data.description || res.data.message)) || '').toLowerCase();
        var bad = items.filter(function (i) { return desc && desc.indexOf((i._title || '').toLowerCase().slice(0, 24)) > -1; })[0];
        var keep = bad ? items.filter(function (i) { return i !== bad; }) : items.slice(0, -1);
        if (!keep.length) throw new Error('none');
        return postAdd(keep).then(function (r2) {
          if (r2.ok) return { added: keep.length, total: total, dropped: bad ? bad._title : 'one item' };
          throw new Error('retry-failed');
        });
      }
      throw new Error('failed');
    }).then(function (out) {
      btn.disabled = false;
      btn.textContent = out.added < total || out.dropped ? ('Added ' + out.added + ' of ' + total + (out.dropped ? ' — ' + out.dropped + ' is sold out' : '')) : 'Routine added ✓';
      setCartAttributes();
      refreshCart(); openCart();
      setTimeout(function () { btn.textContent = orig; }, 4000);
    }).catch(function () {
      btn.disabled = false; btn.textContent = 'Couldn’t add — try again';
      setTimeout(function () { btn.textContent = orig; }, 3000);
    });
  }

  function addLines(items, btn, doneLabel) {
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    postAdd(items).then(function (res) {
      if (!res.ok) { var e = new Error('add'); e.soldOut = res.status === 422; throw e; }
      if (btn) { btn.textContent = doneLabel || 'Added ✓'; btn.classList.add('is-added'); btn.disabled = false; }
      setCartAttributes(); refreshCart();
    }).catch(function (err) {
      if (btn) { btn.textContent = (err && err.soldOut) ? 'Sold out' : 'Try again'; btn.disabled = false; }
    });
  }

  function setCartAttributes() {
    var attrs = { quiz: encodeR() };
    if (state.src) attrs.quiz_src = state.src;
    if (state.video) attrs.quiz_video = state.video;
    if (state.topic) attrs.quiz_topic = state.topic;
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
  }

  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-lv-cart-count], .lv-cart-count, .cart-count, [data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
      root.querySelectorAll('[data-sq-viewbag]').forEach(function (el) { el.hidden = !c.item_count; el.textContent = 'View bag (' + c.item_count + ') →'; });
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:build'));
    }).catch(function () {});
  }
  function openCart() {
    var trig = document.querySelector('.js-show-cart, [data-action="open-cart"], a[href="/cart"], .header-cart, .site-header__cart');
    if (trig && trig.tagName !== 'A') { trig.click(); return; }
    document.dispatchEvent(new CustomEvent('cart:open'));
  }

  /* ---------- Klaviyo ---------- */
  var klaviyoSent = false;
  function routinePayload() {
    var routine = [];
    tierSteps().forEach(function (s) {
      var p = currentPick(s);
      if (p) routine.push({ step: s, handle: p.handle, title: p.title, price: (p.price / 100), url: location.origin + (p.url || ('/products/' + p.handle)), image: absUrl(p.image) });
    });
    return routine;
  }
  function permalink() {
    var ids = [];
    tierSteps().forEach(function (s) { var p = currentPick(s); if (p && p.available) ids.push(p.variantId + ':1'); });
    if (!ids.length) return '';
    // Native cart permalink. NEVER discount= or ref= here — creator codes are the attribution rail
    // and GoAffPro reads ?ref; the quiz travels as a cart attribute instead.
    return location.origin + '/cart/' + ids.join(',') + '?storefront=true&attributes%5Bquiz%5D=' + encodeURIComponent(encodeR());
  }
  function submitEmail(email) {
    if (klaviyoSent) return Promise.resolve();
    klaviyoSent = true;
    var company = root.getAttribute('data-klaviyo-company') || 'WHPLHq';
    var list = (root.getAttribute('data-klaviyo-list') || '').trim();
    if (list === 'StVWVi') list = ''; // never the Welcome Series list
    var tot = tierTotals();
    var profileProps = { skin_type: state.type, concern: state.concerns[0] || 'none', sensitive: state.sensitive, spf_flag: state.spf };
    if (state.src) profileProps.quiz_src = state.src;
    if (state.video) profileProps.quiz_video = state.video;
    if (state.topic) profileProps.quiz_topic = state.topic;
    var eventProps = {
      skin_type: state.type, concern: state.concerns[0] || 'none', concerns: state.concerns, sensitive: state.sensitive, spf_flag: state.spf,
      tier: TIER_CODE[state.tier] || 'essential3',
      totals: { simple3: tot.s3 / 100, essential3: tot.e3 / 100, complete5: tot.c5 / 100 },
      routine: routinePayload(),
      result_url: location.origin + location.pathname + '?r=' + encodeURIComponent(encodeR()),
      permalink: permalink()
    };
    if (state.src) { eventProps.src = state.src; eventProps.video = state.video || ''; eventProps.topic = state.topic || ''; }
    var rev = '2024-10-15';
    try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify(Object.assign({ $email: email }, profileProps)); } catch (e) {}
    var subP = list ? fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + company, {
      method: 'POST', headers: { 'Content-Type': 'application/json', revision: rev },
      body: JSON.stringify({ data: { type: 'subscription', attributes: { custom_source: 'Skin Quiz', profile: { data: { type: 'profile', attributes: { email: email, properties: profileProps } } } }, relationships: { list: { data: { type: 'list', id: list } } } } })
    }).then(function (r) { if (!r.ok) console.warn('[skin-quiz] Klaviyo subscription failed: HTTP ' + r.status); return r; })
      .catch(function (e) { console.warn('[skin-quiz] Klaviyo subscription error:', e); }) : Promise.resolve();
    var evP = fetch('https://a.klaviyo.com/client/events/?company_id=' + company, {
      method: 'POST', headers: { 'Content-Type': 'application/json', revision: rev },
      body: JSON.stringify({ data: { type: 'event', attributes: { metric: { data: { type: 'metric', attributes: { name: 'Completed Skin Quiz' } } }, properties: eventProps, profile: { data: { type: 'profile', attributes: { email: email, properties: profileProps } } } } } })
    }).then(function (r) { if (!r.ok) console.warn('[skin-quiz] Klaviyo event failed: HTTP ' + r.status); return r; })
      .catch(function (e) { console.warn('[skin-quiz] Klaviyo event error:', e); });
    return Promise.all([subP, evP]);
  }

  /* ---------- entry points (ManyChat + shared results) ---------- */
  function initFromURL() {
    var qs;
    try { qs = new URLSearchParams(location.search); } catch (e) { return false; }
    state.src = qs.get('src') || null;
    state.video = qs.get('video') || null;
    state.topic = qs.get('topic') || null;

    var r = qs.get('r');
    if (r && decodeR(r)) {
      buildResult(); renderResult(); show('result');
      try { history.replaceState({ sq: 'result' }, '', location.href); } catch (e) {}
      return true;
    }
    var bundle = qs.get('bundle');
    if (bundle && BUNDLE_ALIAS[bundle]) bundle = BUNDLE_ALIAS[bundle];
    if (bundle && BUNDLE_PRESEED[bundle]) {
      var pre = BUNDLE_PRESEED[bundle];
      state.type = pre.type; state.concerns = pre.concerns.slice(); state.sensitive = !!pre.sensitive;
      state.bundleReq = bundle;
      // show the bundle's own components where the engine's scored set allows it (a swap, not an override)
      var liveB = BUNDLES.filter(function (b) { return b.handle === bundle && b.available; })[0];
      if (liveB) bundleComponents(liveB).forEach(function (h) {
        var prod = PRODUCTS.filter(function (p) { return p.handle === h; })[0];
        var stepTag = prod && prod.tags.filter(function (t) { return t.indexOf('step:') === 0; })[0];
        if (stepTag && TIER_STEPS.e3.indexOf(stepTag.slice(5)) > -1) state.swaps[stepTag.slice(5)] = h;
      });
      buildResult(); renderResult(); show('result');
      return true;
    }
    var concern = qs.get('concern');
    if (concern && CONCERN_LABEL[concern]) {
      var qi = Q[0].options.map(function (o) { return o.concern; }).indexOf(concern);
      if (qi > -1) {
        state.answers.q1 = [qi]; recompute();
        var note = root.querySelector('[data-sq-preseed]');
        if (note) { note.hidden = false; note.textContent = 'Because you asked about ' + CONCERN_LABEL[concern] + ' — we’ve started there. You can change it.'; }
      }
    }
    var ing = qs.get('ingredient');
    if (ing && LOVE_OPTS.some(function (o) { return o[0] === ing; })) state.love = ing;
    return false;
  }

  /* ---------- events ---------- */
  root.querySelector('[data-sq-start]').addEventListener('click', function () {
    state.idx = 0; renderQuestion(); show('quiz');
    try { history.pushState({ sq: 'quiz' }, '', location.pathname + location.search); } catch (e) {}
  });
  root.querySelector('[data-sq-back]').addEventListener('click', back);
  root.querySelector('[data-sq-skip]').addEventListener('click', skipQ);
  root.querySelector('[data-sq-restart]').addEventListener('click', function () {
    state.answers = {}; state.love = null; state.avoid = null; state.swaps = {}; state.tier = 'e3'; state.tierChosen = false; state.addMoist = false; state.addSpf = false; state.idx = 0;
    recompute();
    try { history.pushState({ sq: 'intro' }, '', location.pathname); } catch (e) {}
    show('intro');
  });
  window.addEventListener('popstate', function (ev) {
    var s = ev.state && ev.state.sq;
    if (s === 'result') {
      var qs = new URLSearchParams(location.search); var r = qs.get('r');
      if (r && decodeR(r)) { buildResult(); renderResult(); show('result'); return; }
    }
    if (s === 'quiz') { renderQuestion(); show('quiz'); return; }
    show('intro');
  });

  var form = root.querySelector('[data-sq-email-form]');
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = root.querySelector('[data-sq-email-input]');
    var msg = root.querySelector('[data-sq-email-msg]');
    var email = (input.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) { msg.hidden = false; msg.textContent = 'Please enter a valid email.'; return; }
    msg.hidden = true;
    submitEmail(email).then(function () {
      form.hidden = true;
      root.querySelector('[data-sq-email-success]').hidden = false;
    });
  });
  root.querySelector('[data-sq-copy]').addEventListener('click', function () {
    var code = root.querySelector('[data-sq-code]').textContent;
    if (navigator.clipboard) navigator.clipboard.writeText(code);
    this.textContent = 'Copied';
    var self = this; setTimeout(function () { self.textContent = 'Copy'; }, 1500);
  });

  var introImg = root.querySelector('[data-sq-intro-img]');
  if (introImg) introImg.src = root.getAttribute('data-intro-image');

  document.addEventListener('keydown', function (e) {
    if (screens.quiz.hidden) return;
    var n = parseInt(e.key, 10);
    if (n >= 1 && n <= 9) { var opts = root.querySelectorAll('[data-sq-options] .sq-opt'); if (opts[n - 1]) opts[n - 1].click(); }
  });

  initFromURL();
})();
